import { render, staticRenderFns } from "./eComplaintAccesses.vue?vue&type=template&id=4cc1c2a9"
import script from "./eComplaintAccesses.vue?vue&type=script&lang=js"
export * from "./eComplaintAccesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports